import React from 'react';
import PropTypes from 'prop-types';
import {withI18n} from 'spa/Components/Context';

import CenteredCopyContainer from 'spa/Pages/Landing/Verticals/Components/CenteredCopyContainer';
import ProgressiveBackgroundImage from 'spa/Components/ProgressiveBackgroundImage';

import 'spa/Pages/Landing/Verticals/Sections/wellness-section.less';

@withI18n
class WellnessSection extends React.Component {
  static propTypes = {
    useYellowLine: PropTypes.bool,
  };

  UNSAFE_componentWillMount() {
    const {useYellowLine} = this.props;

    if (!useYellowLine) {
      this.lineImage = {
        highResImg: 'https://res.cloudinary.com/huxr6hrje/image/upload/f_auto/v1555087511/b2c-vertical-landing/stats/stats_2x.jpg',
        highResImg2x: 'https://res.cloudinary.com/huxr6hrje/image/upload/f_auto/v1555087511/b2c-vertical-landing/stats/stats_3x.jpg',
        lowResImg: 'https://res.cloudinary.com/huxr6hrje/image/upload/f_auto/v1555087511/b2c-vertical-landing/stats/stats.jpg',
        mediaQueries: [
          {
            query: '(max-width: 768px)',
            lowResImg: 'https://res.cloudinary.com/huxr6hrje/image/upload/f_auto/v1555087511/b2c-vertical-landing/stats/stats_m.jpg',
            highResImg: 'https://res.cloudinary.com/huxr6hrje/image/upload/f_auto/v1555087511/b2c-vertical-landing/stats/stats_m_2x.jpg',
            highResImg2x: 'https://res.cloudinary.com/huxr6hrje/image/upload/f_auto/v1555087511/b2c-vertical-landing/stats/stats_m_3x.jpg',
          },
        ],
      };
    } else {
      this.lineImage = {
        highResImg: 'https://res.cloudinary.com/huxr6hrje/image/upload/f_auto/v1557825874/b2c-art/urban-stats/stats_2x.jpg',
        highResImg2x: 'https://res.cloudinary.com/huxr6hrje/image/upload/f_auto/v1557825874/b2c-art/urban-stats/stats_3x.jpg',
        lowResImg: 'https://res.cloudinary.com/huxr6hrje/image/upload/f_auto/v1557825874/b2c-art/urban-stats/stats.jpg',
        mediaQueries: [
          {
            query: '(max-width: 768px)',
            lowResImg: 'https://res.cloudinary.com/huxr6hrje/image/upload/f_auto/v1557825874/b2c-art/urban-stats/stats_m.jpg',
            highResImg: 'https://res.cloudinary.com/huxr6hrje/image/upload/f_auto/v1557825874/b2c-art/urban-stats/stats_m_2x.jpg',
            highResImg2x: 'https://res.cloudinary.com/huxr6hrje/image/upload/f_auto/v1557825874/b2c-art/urban-stats/stats_m_3x.jpg',
          },
        ],
      };
    }
  }

  render() {
    const {context, lineImage} = this;
    const {i18n} = context;

    return (
      <section className="wellness-section">
        <CenteredCopyContainer>
          <h2 className="typography--section-heading typography--guttered-wide-heading typography--centered">{i18n._x('Serving the city since 2014', 'Wellness section title')}</h2>
        </CenteredCopyContainer>
        <div className="wellness-section__content">
          <ProgressiveBackgroundImage
            customClass="wellness-section__background"
            customClassForAmp="wellness-section__background-amp"
            highResImg={lineImage.highResImg}
            highResImg2x={lineImage.highResImg2x}
            lowResImg={lineImage.lowResImg}
            mediaQueries={lineImage.mediaQueries}
          >
            <ul className="wellness-section__list">
              <li className="wellness-section__list-item wellness-section__list-item--offset-bottom">
                <div>
                  <h3 className="wellness-section__list-title">{i18n._x('45,974,450', 'Wellness list title')}</h3>
                  <div className="wellness-section__list-content">{i18n._x('minutes of wellness delivered', 'wellness list content')}</div>
                </div>
              </li>
              <li className="wellness-section__list-item">
                <div>
                  <h3 className="wellness-section__list-title">{i18n._x('347,948', 'Wellness list title')}</h3>
                  <div className="wellness-section__list-content">{i18n._x('5-star ratings on massage alone', 'wellness list content')}</div>
                </div>
              </li>
              <li className="wellness-section__list-item wellness-section__list-item--offset-bottom">
                <div>
                  <h3 className="wellness-section__list-title">{i18n._x('4600+', 'Wellness list title')}</h3>
                  <div className="wellness-section__list-content">{i18n._x('wellness practitioners in two countries', 'wellness list content')}</div>
                </div>
              </li>
              <li className="wellness-section__list-item">
                <div>
                  <h3 className="wellness-section__list-title">{i18n._x('4', 'Wellness list title')}</h3>
                  <div className="wellness-section__list-content">{i18n._x('cities we operate in', 'wellness list content')}</div>
                </div>
              </li>
            </ul>
          </ProgressiveBackgroundImage>
        </div>
      </section>
    );
  }
}

export default WellnessSection;



// WEBPACK FOOTER //
// ./spa/Pages/Home2020/digital/WellnessSectionForDigital.jsx